import React, { useEffect, useState } from "react";
import Axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const PostArticle = () => {
  const navigate = useNavigate();
  const [articleData, setArticleData] = useState({
    title: "",
    createdAt: "",
    articleType: "",
    image: "",
    description: "",
    markdown: "",
  });

  const [image, setImage] = useState("");
  const [url, setUrl] = useState("");

  // const params = useParams()
  // const id = params.id.toString()

  let name, value;
  const dataInputFn = (event) => {
    name = event.target.name;
    value = event.target.value;

    setArticleData({ ...articleData, [name]: value });
  };

  const PostArticleDetailFn = async () => {
    try {
      // const config = {
      //   headers: {"Content-Type": "application/json"},
      //   withCredentials: true
      // }
      // const {title, createdAt, articleType, description, markdown } = articleData;
      return await Axios.post("https://blogappserver-8sw1.onrender.com/articles/new", {
        ...articleData,
        image: url,
      }, { withCredentials: true })
        .then((res) => res.data)
        .then((data) => {
          if (data.error) {
            throw new Error(data.error);
          } else {
            setArticleData(data);
            navigate("/articles", { replace: true });
            toast("successfully created..!!", { type: "success" });
          }
        });
    } catch (error) {
      toast("Try It Again..!!", { type: "error" });
    }
  };

  useEffect(() => {
    if (url) {
      PostArticleDetailFn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  //uploading a image to an cloudinary
  const PostArticleWithImage = async (e) => {
    try {
      e.preventDefault();
      const data = new FormData();
      data.append("file", image);
      data.append("upload_preset", "blogify-web");
      data.append("cloud_name", "ninja-cloud");

      const res = await Axios.post(
        "https://api.cloudinary.com/v1_1/ninja-cloud/image/upload",
        data
      );
      if (res.status === 200) {
        const imageUrl = res.data.secure_url;
        setUrl(imageUrl);
      }
    } catch (error) {
    }
  };

  return (
    <>
      <div className="form-group mb-2">
        <label htmlFor="title">Title
          <span style={{color: "red"}}>[Exceed up to 30 characters]</span>
        </label>
        <input
          required
          type="text"
          name="title"
          id="title"
          value={articleData.title}
          onChange={dataInputFn}
          placeholder="blog title"
          maxLength={30}
          className="form-control"
        />
      </div>

      <div className="form-group mb-2">
        <label htmlFor="type" className="mx-2">
          Article Type
        </label>
        <select name="articleType" id="type" onChange={dataInputFn}>
          <option className="text-muted">None</option>
          <option>Tech</option>
          <option>Sport</option>
          <option>Education</option>
          <option>Life Style</option>
          <option>Food</option>
          <option>Travel</option>
          <option>Marketing</option>
          <option>Business</option>
          <option>Environment</option>
          <option>DIY</option>
        </select>
      </div>

      <div className="form-group mb-2">
        <label htmlFor="image">Image</label>
        <input
          required
          type="file"
          name="image"
          id="image"
          onChange={(e) => setImage(e.target.files[0])}
          className="form-control"
        />
      </div>

      <div className="form-group mb-2">
        <label htmlFor="description">Description
          <span style={{color: "red"}}>[in one sentence..]</span>
        </label>
        <textarea
          required
          name="description"
          id="description"
          value={articleData.description}
          onChange={dataInputFn}
          placeholder="short description about blog"
          maxLength={100}
          className="form-control"
        ></textarea>
      </div>

      <div className="form-group mb-4">
        <label htmlFor="markdown">Markdown Editor: [Write Here Blog]</label>
        <div className="my-2">
          <p className="mk-text">
            • write up in a markdown format-
            <a
              target="_blank"
              href="https://www.markdownguide.org/cheat-sheet/"
              rel="noreferrer" className="mk-text"
            >
              follow link
            </a>
          </p>
        </div>
        <textarea
          required
          name="markdown"
          id="markdown"
          rows="5"
          value={articleData.markdown}
          onChange={dataInputFn}
          placeholder="write up only in mardown format to get a proper visibilty in your blog.."
          className="form-control"
        ></textarea>
      </div>
      <div className="text-center">
        <NavLink to="/articles" className="btn btn-secondary mx-3 px-3">
          Cancel
        </NavLink>
        <button
          type="submit"
          onClick={PostArticleWithImage}
          className="btn btn-primary mx-3 px-4"
        >
          Save
        </button>
      </div>
    </>
  );
};
export default PostArticle;
